<template>
  <div>
    <v-row dense>
      <v-col cols="10" style="margin-top: 10px; margin-bottom: 20px;">
        <h2 class="b-indicator__collapse-title">1. Значение показателя</h2>
        <h3 class="b-indicator__collapse-subtitle">Исходные данные:</h3>
        <p>
          <span class="font-weight-bold mb-1">Форма 5.20. (фрагмент)</span><br>
          Сведения об образовательных программах, реализуемых организацией, сведения об образовательных программах,
          реализуемых с использованием сетевой формы, в которых организация выступает в роли базовой организации
          <br>
          по данным формы ВПО-1, человек
        </p>
      </v-col>
    </v-row>
    <wrapper-preview-category style="max-width: 800px; background: unset; box-shadow: unset">
      <grid-table
        :headers="headers.table_1"
        :headers-for-rows="headersForRows"
        :num-cols="headers.countCells"
        :gap="'0'"
        :data-rows="table"
        type-table="grid"
      >
        <template #qibcg20="{row}" style="justify-content: unset; border-right: 1px solid #b7ced9">
          <div style="display:flex; flex-direction: column" v-if="row.qibcg20 === '1'">
            <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
            <span style="align-self: center; margin-top: 5px;">ЧОСi2020</span>
          </div>
          <div v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.qibcg20, 0, 'integer', true, 0) }}</div>
        </template>
        <template #qibcg21="{row}">
          <div style="display:flex; flex-direction: column" v-if="row.qibcg21 === '2'">
            <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
            <span style="align-self: center; margin-top: 5px;">ЧОСi2021</span>
          </div>
          <div v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.qibcg21, 0, 'integer', true, 0) }}</div>
        </template>
        <template #qibcg22="{row}">
          <div style="display:flex; flex-direction: column" v-if="row.qibcg22 === '3'">
            <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
            <span style="align-self: center; margin-top: 5px;">ЧОСi2022</span>
          </div>
          <div v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.qibcg22, 0, 'integer', true, 0) }}</div>
        </template>
      </grid-table>
    </wrapper-preview-category>

    <v-row dense>
      <v-col cols="10" style="margin-bottom: 20px;">
        <p>
          <span class="font-weight-bold mb-1">Форма 5.02. (фрагмент)</span><br>
          Общая численность обучающихся по программам бакалавриата, программам специалитета, программам магистратуры
          <br>
          по данным формы ВПО-1, человек
        </p>
      </v-col>
    </v-row>

    <div style="display: flex; flex-direction: row">
      <div style="display: flex; flex-direction: row">
        <wrapper-preview-category style="max-width: 1000px; background: unset; box-shadow: unset">
          <grid-table
            :headers="headers.table_2"
            :headers-for-rows="headersForRows2"
            :num-cols="18"
            :gap="'0'"
            :data-rows="table2"
            type-table="grid"
          >
            <template #nb20="{row}">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(row.nb20, 0, 'integer', true, 0) }}
            </template>
            <template #nb21="{row}">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(row.nb21, 0, 'integer', true, 0) }}
            </template>
            <template #nb22="{row}">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(row.nb22, 0, 'integer', true, 0) }}
            </template>
            <template #nq20="{row}">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(row.nq20, 0, 'integer', true, 0) }}
            </template>
            <template #nq21="{row}">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(row.nq21, 0, 'integer', true, 0) }}
            </template>
            <template #nq22="{row}">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(row.nq22, 0, 'integer', true, 0) }}
            </template>
          </grid-table>
        </wrapper-preview-category>
        <div style="display: flex; flex-direction: column; justify-content: space-between; margin: 200px 0 80px 25px;">
          <img style="width: 76px" :src="require('@/assets/images/Vector_rigth_arrow.svg')" alt=""/>
        </div>
      </div>
      <wrapper-preview-category
        style="max-width: 500px; margin-left: 30px; margin-top: 50px; background: unset; box-shadow: unset">
        <grid-table
          :headers="headers.table_3"
          :headers-for-rows="headersForRows3"
          :num-cols="3"
          :gap="'0'"
          :data-rows="table3"
          type-table="grid"
        >
          <template #no20="{row}">
            <div style="display:flex; flex-direction: column" v-if="row.no20 === '---'">
              <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
              <span style="align-self: center; margin-top: 5px">
                {{ valueForBsm2 }}
              </span>
              <span style="align-self: center; margin-top: 5px; font-weight: 700">ЧОi2020</span>
            </div>
            <span style="min-height: 18px" v-else-if="row.no20 === '' && row.no21 === '' && row.no22 === ''"></span>
            <span v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.no20, 0, 'integer', true, 0) }}</span>
          </template>
          <template #no21="{row}">
            <div style="display:flex; flex-direction: column" v-if="row.no21 === '---'">
              <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
              <span style="align-self: center; margin-top: 5px">
                {{ valueForBsm4 }}
              </span>
              <span style="align-self: center; margin-top: 5px; font-weight: 700">ЧОi2021</span>
            </div>
            <span style="min-height: 18px" v-else-if="row.no20 === '' && row.no21 === '' && row.no22 === ''"></span>
            <span v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.no21, 0, 'integer', true, 0) }}</span>
          </template>
          <template #no22="{row}">
            <div style="display:flex; flex-direction: column" v-if="row.no22 === '---'">
              <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
              <span style="align-self: center; margin-top: 5px">
                {{ valueForBsm6 }}
              </span>
              <span style="align-self: center; margin-top: 5px; font-weight: 700">ЧОi2022</span>
            </div>
            <span style="min-height: 18px" v-else-if="row.no20 === '' && row.no21 === '' && row.no22 === ''"></span>
            <span v-else>{{ $scripts.TableJs.checkValueWithNullAndReturnND(row.no22, 0, 'integer', true, 0) }}</span>
          </template>
        </grid-table>
      </wrapper-preview-category>
    </div>
    <div
      style="display: flex; flex-direction: column; align-items: flex-end; margin-left: auto; width: 1000px; margin-top: -65px; margin-right: 230px;">
      <div style="display: flex; flex-direction: row; width: 100%; justify-content: center; padding-left: 30px;">
        <span style="margin-right: 25px; color: gray">сумма по формам обучения:</span>
      </div>
    </div>

    <h3 class="b-indicator__collapse-subtitle mt-5">Расчет значения показателя:</h3>
    <div class="d-flex flex-row align-center">
      <formulsFraction :need-bottom-line="true">
        <template>
          <div class="d-flex flex-row align-end">
            {{ item.title }}
            <div class="little-text ">0</div>
          </div>
        </template>
        <template #bottom>значение<br> показателя</template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> = (</span>
        </template>
      </formulsFraction>
      <!--         /////////////////////////////////////////////                   -->
      <formulsFractionSimple>
        <template>
          ЧОСi2020
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            ЧОi2020
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          ЧОСi2021
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            ЧОi2021
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          ЧОСi2022
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            ЧОi2022
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">) × 100 </span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">÷ <span class="ml-1">k</span></span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <!--     ///////////////////////////////////////////////    -->
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> (</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm1, 0, 'integer') }}
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm2, 0, 'integer') }}
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm3, 0, 'integer') }}
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm4, 0, 'integer') }}
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm5, 0, 'integer') }}
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(valueForBsm6, 0, 'integer') }}
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">) × 100 </span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">÷ <span class="ml-1">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.qipngq3, 0, 'integer') }}
          </span>
          </span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">{{ rowOfValues.data[valueForBsm7] }}</span>
        </template>
      </formulsFraction>
      <!--     ///////////////////////////////////////////////    -->
    </div>
    <p style="max-width: unset">ЧОСi - {{ textForBSM1 }};</p>
    <p>ЧОi - {{ textForBSM2 }}</p>
    <p>k - количество лет, за которые имеются отчетные данные.</p>
  </div>
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import config from "@/components/cards/indicatiors/cardsTables/config/b26";
import formulsFraction from "@/components/cards/indicatiors/formulsFraction";
import formulsFractionSimple from "@/components/cards/indicatiors/formulsFractionSimple";

export default {
  name: "b26",
  components: {GridTable, WrapperPreviewCategory, formulsFraction, formulsFractionSimple},
  props: {
    item: {
      type: Object
    },
    rowOfValues: {
      type: Object,
      default: () => {
      }
    },
  },
  data() {
    return {
      headers: config,
      table: [],
      table2: [],
      table3: []
    }
  },
  computed: {
    headersForRows() {
      return this.headers.table_1.reduce((acc, el) => {
        if (el.variable) {
          acc.push({...el, rows: 1});
        }
        return acc;
      }, [])
    },
    headersForRows2() {
      return this.headers.table_2.reduce((acc, el) => {
        if (el.variable) {
          acc.push({...el, rows: 1});
        }
        return acc;
      }, [])
    },
    headersForRows3() {
      return this.headers.table_3.reduce((acc, el) => {
        if (el.variable) {
          acc.push({...el, rows: 1});
        }
        return acc;
      }, [])
    },
    textForBSM1() {
      if (this.item.idUsl === 1) {
        return `число обучающихся по программам бакалавриата, реализуемым с использованием сетевой формы в i-ой образовательной организации;`
      } else if (this.item.idUsl === 2) {
        return `число обучающихся по программам специалитета, реализуемым с использованием сетевой формы в i-ой образовательной организации;`
      } else if (this.item.idUsl === 3) {
        return `число обучающихся по программам магистратуры, реализуемым с использованием сетевой формы в i-ой образовательной организации;`
      } else {
        return ''
      }
    },
    textForBSM2() {
      if (this.item.idUsl === 1) {
        return `число обучающихся по программам бакалавриата в i-ой образовательной организации;`
      } else if (this.item.idUsl === 2) {
        return `число обучающихся по программам специалитета в i-ой образовательной организации;`
      } else if (this.item.idUsl === 3) {
        return `число обучающихся по программам магистратуры в i-ой образовательной организации;`
      } else {
        return ''
      }
    },
    valueForBsm1() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.nnbcs20
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.nnsps20
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.nnmgs20
      } else {
        return ''
      }
    },
    valueForBsm2() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.nobcs20
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.nosps20
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.nomgs20
      } else {
        return ''
      }
    },
    valueForBsm3() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.nnbcs21
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.nnsps21
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.nnmgs21
      } else {
        return ''
      }
    },
    valueForBsm4() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.nobcs21
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.nosps21
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.nomgs21
      } else {
        return ''
      }
    },
    valueForBsm5() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.nnbcs22
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.nnsps22
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.nnmgs22
      } else {
        return ''
      }
    },
    valueForBsm6() {
      if (this.item.idUsl === 1) {
        return this.rowOfValues.data.nobcs22
      } else if (this.item.idUsl === 2) {
        return this.rowOfValues.data.nosps22
      } else if (this.item.idUsl === 3) {
        return this.rowOfValues.data.nomgs22
      } else {
        return ''
      }
    },
    valueForBsm7() {
      return String(this.item.dataFieldName) + 'b022'
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.table = [
        {
          bsm: '',
          qibcg20: '1',
          qibcg21: '2',
          qibcg22: '3',
        },
      ];

      if (this.item.idUsl === 1) {
        this.table.unshift({
          bsm: 'Бакалавриат',
          qibcg20: this.rowOfValues.data.nnbcs20,
          qibcg21: this.rowOfValues.data.nnbcs21,
          qibcg22: this.rowOfValues.data.nnbcs22,
        });

        this.table2 = [
          {
            bsm: 'Бакалавриат',
            fo: 'очная форма',
            nb20: this.rowOfValues.data.nsbco20,
            nb21: this.rowOfValues.data.nsbco21,
            nb22: this.rowOfValues.data.nsbco22,
            xxx: '...',
            nq20: this.rowOfValues.data.nqbco20,
            nq21: this.rowOfValues.data.nqbco21,
            nq22: this.rowOfValues.data.nqbco22,
          },
          {
            bsm: 'Бакалавриат',
            fo: 'очно-заочная форма',
            nb20: this.rowOfValues.data.nsbcv20,
            nb21: this.rowOfValues.data.nsbcv21,
            nb22: this.rowOfValues.data.nsbcv22,
            xxx: '...',
            nq20: this.rowOfValues.data.nqbcv20,
            nq21: this.rowOfValues.data.nqbcv21,
            nq22: this.rowOfValues.data.nqbcv22,
          },
          {
            bsm: 'Бакалавриат',
            fo: 'заочная форма',
            nb20: this.rowOfValues.data.nsbcz20,
            nb21: this.rowOfValues.data.nsbcz21,
            nb22: this.rowOfValues.data.nsbcz22,
            xxx: '...',
            nq20: this.rowOfValues.data.nqbcz20,
            nq21: this.rowOfValues.data.nqbcz21,
            nq22: this.rowOfValues.data.nqbcz22,
          }
        ];
        this.table3 = [
          {
            no20: this.rowOfValues.data.nobco20,
            no21: this.rowOfValues.data.nobco21,
            no22: this.rowOfValues.data.nobco22,
          },
          {
            no20: this.rowOfValues.data.nobcv20,
            no21: this.rowOfValues.data.nobcv21,
            no22: this.rowOfValues.data.nobcv22,
          },
          {
            no20: this.rowOfValues.data.nobcz20,
            no21: this.rowOfValues.data.nobcz21,
            no22: this.rowOfValues.data.nobcz22,
          },
          {
            bsm: '',
            no20: '---',
            no21: '---',
            no22: '---',
          },
        ]
      } else if (this.item.idUsl === 2) {
        this.table.unshift({
          bsm: 'Специалитет',
          qibcg20: this.rowOfValues.data.nnsps20,
          qibcg21: this.rowOfValues.data.nnsps21,
          qibcg22: this.rowOfValues.data.nnsps22,
        })

        this.table2 = [
          {
            bsm: 'Специалитет',
            fo: 'очная форма',
            nb20: this.rowOfValues.data.nsspo20,
            nb21: this.rowOfValues.data.nsspo21,
            nb22: this.rowOfValues.data.nsspo22,
            xxx: '...',
            nq20: this.rowOfValues.data.nqspo20,
            nq21: this.rowOfValues.data.nqspo21,
            nq22: this.rowOfValues.data.nqspo22,
          },
          {
            bsm: 'Специалитет',
            fo: 'очно-заочная форма',
            nb20: this.rowOfValues.data.nsspv20,
            nb21: this.rowOfValues.data.nsspv21,
            nb22: this.rowOfValues.data.nsspv22,
            xxx: '...',
            nq20: this.rowOfValues.data.nqspv20,
            nq21: this.rowOfValues.data.nqspv21,
            nq22: this.rowOfValues.data.nqspv22,
          },
          {
            bsm: 'Специалитет',
            fo: 'заочная форма',
            nb20: this.rowOfValues.data.nsspz20,
            nb21: this.rowOfValues.data.nsspz21,
            nb22: this.rowOfValues.data.nsspz22,
            xxx: '...',
            nq20: this.rowOfValues.data.nqspz20,
            nq21: this.rowOfValues.data.nqspz21,
            nq22: this.rowOfValues.data.nqspz22,
          }];

        this.table3 = [
          {
            no20: this.rowOfValues.data.nospo20,
            no21: this.rowOfValues.data.nospo21,
            no22: this.rowOfValues.data.nospo22,
          },
          {
            no20: this.rowOfValues.data.nospv20,
            no21: this.rowOfValues.data.nospv21,
            no22: this.rowOfValues.data.nospv22,
          },
          {
            no20: this.rowOfValues.data.nospz20,
            no21: this.rowOfValues.data.nospz21,
            no22: this.rowOfValues.data.nospz22,
          },
          {
            bsm: '',
            no20: '---',
            no21: '---',
            no22: '---',
          },
        ]
      } else if (this.item.idUsl === 3) {
        this.table.unshift({
          bsm: 'Магистратура',
          qibcg20: this.rowOfValues.data.nnmgs20,
          qibcg21: this.rowOfValues.data.nnmgs21,
          qibcg22: this.rowOfValues.data.nnmgs22,
        });

        this.table2 = [
          {
            bsm: 'Магистратура',
            fo: 'очная форма',
            nb20: this.rowOfValues.data.nsmgo20,
            nb21: this.rowOfValues.data.nsmgo21,
            nb22: this.rowOfValues.data.nsmgo22,
            xxx: '...',
            nq20: this.rowOfValues.data.nqmgo20,
            nq21: this.rowOfValues.data.nqmgo21,
            nq22: this.rowOfValues.data.nqmgo22,
          },
          {
            bsm: 'Магистратура',
            fo: 'очно-заочная форма',
            nb20: this.rowOfValues.data.nsmgv20,
            nb21: this.rowOfValues.data.nsmgv21,
            nb22: this.rowOfValues.data.nsmgv22,
            xxx: '...',
            nq20: this.rowOfValues.data.nqmgv20,
            nq21: this.rowOfValues.data.nqmgv21,
            nq22: this.rowOfValues.data.nqmgv22,
          },
          {
            bsm: 'Магистратура',
            fo: 'заочная форма',
            nb20: this.rowOfValues.data.nsmgz20,
            nb21: this.rowOfValues.data.nsmgz21,
            nb22: this.rowOfValues.data.nsmgz22,
            xxx: '...',
            nq20: this.rowOfValues.data.nqmgz20,
            nq21: this.rowOfValues.data.nqmgz21,
            nq22: this.rowOfValues.data.nqmgz22,
          }];
        this.table3 = [{
          no20: this.rowOfValues.data.nomgo20,
          no21: this.rowOfValues.data.nomgo21,
          no22: this.rowOfValues.data.nomgo22,
        },
          {
            no20: this.rowOfValues.data.nomgv20,
            no21: this.rowOfValues.data.nomgv21,
            no22: this.rowOfValues.data.nomgv22,
          },
          {
            no20: this.rowOfValues.data.nomgz20,
            no21: this.rowOfValues.data.nomgz21,
            no22: this.rowOfValues.data.nomgz22,
          },
          {
            bsm: '',
            no20: '---',
            no21: '---',
            no22: '---',
          },
        ]
      }
    }
  }
}
</script>

<style lang="sass" scoped>

</style>